module.exports = __webpack_public_path__ + "static/media/arrow-right.0889fd8b.svg";